import { useTranslation } from "@i18n/hooks";

import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { FilesTable } from "../../features/files/files-table";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const FilesScreen = () => {
	const { t } = useTranslation("common");
	const canRead = useHasPermissions("onlyOwnerOfRoot");

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("files.screenTitle")}>
			<FilesTable canUploadFiles={true} canDeleteFiles={true} />
		</BaseScreen>
	);
};
